import React from "react";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import AppBar from "@material-ui/core/AppBar";
import Box from "@material-ui/core/Box";
import ExamsAdminTab from "./ExamsAdminTab";
import TermsAdminTab from "./TermsAdminTab";
import ExamsCoordExtraordinaryExamsView from "../Coordinator/ExamsCoordExtraordinaryExamsView";
import ExamsCoordExtraordinaryPetitionView from "../Coordinator/ExamsCoordExtraordinaryPetitionView";

const ExamsAdminView = () => {

    const [value, setValue] = React.useState(0);

    const handleTabChange = (event, newValue) => {
        setValue(newValue);
    };

    function TabPanel(props) {
        return(
            <div role="tabpanel"
                 hidden={value !== props.index}
                 id={`tabpanel-${props.index}`}
                 aria-labelledby={`full-width-tab-${props.index}`}>
                { value === props.index && (
                    <Box>
                        {props.component}
                    </Box>
                )}
            </div>
        )
    }

    return (
        <React.Fragment>
            <AppBar position={"static"}>
                <Tabs variant={"fullWidth"} value={value} onChange={handleTabChange}>
                    <Tab label={"Examenes"} />
                    <Tab label={"Convocatorias"} />
                    <Tab label={"Examenes extraordinarios"} />
                    <Tab label={"Peticiones fuera de plazo"} />
                </Tabs>
            </AppBar>
            <TabPanel index={0} component={ExamsAdminTab}/>
            <TabPanel index={1} component={TermsAdminTab}/>
            <TabPanel index={2} component={ExamsCoordExtraordinaryExamsView}/>
            <TabPanel index={3} component={ExamsCoordExtraordinaryPetitionView}/>
        </React.Fragment>
    )
}

export default ExamsAdminView